// extracted by mini-css-extract-plugin
export default {"root":"FilterWell__root--zvjH07","filterWell":"FilterWell__filterWell--3EvIjd","border":"FilterWell__border--DEWTgu","content":"FilterWell__content--8bi0k0"};